<template>
  <div id="index">
    <el-row
      class="tac"
      v-if="$route.meta.menu != 'detail' && $route.meta.menu != 'bankrupt'"
    >
      <el-col :span="24" class="Box">
        <div
          style="
            display: flex;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid #eeeff2;
            margin-bottom: 24px;
          "
          v-if="this.$store.state.inputstatus == 0"
        >
          <el-menu
            :default-active="$route.path | getRouterActive"
            class="el-menu-demo"
            text-color="#333"
            @select="SelectMenu"
            :key="key"
          >
            <el-menu-item
              v-for="(item, index) in targetRoutes"
              :key="index"
              :index="item.path"
              >{{ item.meta.title }}</el-menu-item
            >
          </el-menu>
          <!-- <div class="kb"></div> -->
          <el-button
            class="btn"
            type="success"
            @click="enter()"
            v-if="
              this.$store.state.menustatus != 1 &&
              this.$store.state.rolesname.includes('caseinput')
            "
          >
            案件录入
          </el-button>
        </div>
        <!-- <Table :list="list" :loading="loading"/> -->

        <!-- <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive> -->
        <router-view @value="getvalue"></router-view>
      </el-col>
    </el-row>
    <div class="Bid" v-else>
      <el-card
        class="index"
        v-if="$route.name != 'Bidinput' && $route.name != 'bankinput'"
      >
        <div class="menu" style="margin-bottom: 24px">
          <el-menu
            :default-active="$route.name"
            :key="key"
            class="el-menu-demo"
            mode="horizontal"
            @select="SelectMenu"
          >
            <!-- <el-menu-item index="bankrupt">破产案例</el-menu-item> -->
            <el-menu-item
              v-for="(item, index) in targetRoutes"
              :key="index"
              :index="item.path"
            >
              {{ item.meta.title }}
            </el-menu-item>
          </el-menu>
        </div>
        <router-view @value="getvalue"></router-view>
      </el-card>
      <router-view v-else @value="getvalue"></router-view>
    </div>
    <el-dialog
      title="选择案件类型"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <!-- <div style="width: 100%;text-align: centers;">新增代办</div> -->
      <el-form ref="enterForm" :model="enterForm">
        <!-- <el-form-item label="活动名称" label-width="80px">
            <el-input v-model="editForm.content"></el-input>
          </el-form-item> -->

        <el-form-item
          label="案件类型"
          label-width="80px"
          style="margin-left: 16%"
        >
          <el-select
            v-model="status"
            class="all-select"
            clearable
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="callOf('enterForm')">取 消</el-button>
        <el-button type="primary" @click="confirm(status)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { caseInsertMenu } from '../../api/case'
export default {
  name: 'case',
  // components:{
  //   Table
  // },
  data() {
    return {
      // isIndex: false,
      status: '',
      list: [],
      loading: false,
      dialogVisible: false,
      statusOptions: [
        // { label: '民事案件', value: '00000000-0000-0000-0001-000000000000' },
        // { label: '刑事案件', value: '00000000-0001-0001-0002-000000000000' },
        // { label: '行政案件', value: '00000000-0002-0002-0003-000000000000' },
        // { label: '执行案件', value: '00000000-0003-0003-0004-000000000000' },
        // {
        //   label: '劳动仲裁案件',
        //   value: '00000000-0004-0004-0005-000000000000'
        // },
        // {
        //   label: '商事仲裁案件',
        //   value: '00000000-0005-0005-0006-000000000000'
        // },
        // {
        //   label: '一般非诉项目',
        //   value: '00000000-0006-0006-0007-000000000000'
        // },
        // {
        //   label: '单独出具法律意见审批书',
        //   value: '00000000-0007-0007-0008-000000000000'
        // },
        // {
        //   label: '单独出具律师函',
        //   value: '00000000-0008-0008-0009-000000000000'
        // },
        // {
        //   label: '其他与法律服务有关的招投标引项目栏',
        //   value: '00000000-0009-0009-0010-000000000000'
        // },
        // { label: '专项服务合同', value: '00000000-0010-0010-0011-000000000000' }
      ],
      enterForm: {},
      menu: true,
      next: false
    }
  },
  async created() {
    await this.GetInsertMenu()
  },
  methods: {
    getvalue(value) {
      //获取子组件的值
      this.next = value
    },
    async GetInsertMenu() {
      await caseInsertMenu({}).then((res) => {
        if (res.data.status == 'success') {
          this.statusOptions = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    enter() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    callOf() {
      this.dialogVisible = false
    },

    confirm(status) {
      if (status == '' || status == null) {
        return this.$message.error('请选择案件类型！')
      }
      this.dialogVisible = false
      var num = status.substring(21, 23)
      if (num == 12) {
        this.$router.push({
          path: '/home/case/bankinput'
        })
      } else if (num == 13) {
        this.$router.push({
          path: '/home/case/Bidinput'
        })
      } else {
        this.$store.commit('setinputstatus', 1)
        if (this.$store.state.inputstatus == 1) {
          this.menu = false
        } else {
          this.menu = true
        }
        this.$router.push({
          path: 'caseinput',
          query: { status: status, num: num, sup: false }
        })
      }
      this.status = ''
    },
    SelectMenu(item) {
      // console.log(this.$route)
      // console.log(item)
      // console.log(this.$route.query.guid)
      // console.log(this.$route.query.caseType)
      this.$store.commit('setPage', 1)
      this.$router.push({
        query: {
          guid: this.$route.query.guid,
          status: this.$route.query.status,
          caseType: this.$route.query.caseType,
          mystatus: this.$route.query.mystatus,
          type: this.$route.query.type
        },
        path: item
      })
    },
    routeMenu(path) {
      let str = this.$route.path.split('/')
      // console.log("srr",str)
      if (str[3] == 'caseinfo' || str[3] == 'casetext') {
        this.isIndex = true
      } else {
        this.isIndex = false
      }
      // console.log("this.isIndex",this.isIndex)
    }

    // ...mapActions("case", ["getPublicParams"]),
    // navFilter() {
    //   // const newarr=this.routes.splice(0,1);
    //   var arr = [];

    //   this.targetRoutes.forEach((element, index) => {
    //     // if (index !== 0) {
    //     //   // element.meta.title='首页'
    //     //   // element.path = "" + element.path;
    //     //   // arr.push(element);
    //     // }
    //     element.path = "" + element.path;
    //     arr.push(element);
    //   });
    //   // console.log("oooooooo",arr);
    //   this.menuItem = arr;

    //   console.log("this.routes-------", this.routes);
    // }
  },
  filters: {
    getRouterActive(path) {
      let str = path.split('/')
      // console.log(that.$route.path)
      return str[3]
    }
  },
  computed: {
    targetRoutes() {
      // console.log()
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/case' //遍历每一个数组，过滤出返回值委true的值
      )
      let arr
      this.routeMenu()
      if (this.$store.state.menustatus == '0') {
        // console.log("if:" + this.$store.state.menustatus);
        if (this.next) {
          arr = target[0].children.filter(
            (el) => el.hidden == true && el.meta.menu == 'detail'
          )
        } else {
          arr = target[0].children.filter((el) => el.hidden != true)
        }
      } else {
        arr = target[0].children.filter(
          (el) =>
            el.hidden == true &&
            el.name != 'commitCase' &&
            el.name != 'caseinput' &&
            el.meta.menu != 'detail' &&
            el.meta.menu != 'bankrupt'
          // (el) => el.hidden == true
        )

        // console.log("else:" + this.$store.state.menustatus);
      }
      // arr = target[0].children.filter((el) => el.hidden != true);
      // console.log(arr);
      return arr
    },
    key() {
      // console.log("key:" + this.$store.state.menustatus);

      if (this.$store.state.menustatus != '0') {
        return 'caseinfo'
      } else {
        if (this.next) {
          return 'bankruptdetail'
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
#index {
  .tac {
    .el-menu {
      display: flex;
      height: 55px;
      text-align: center;
      border-right: 0px;

      // margin-bottom: 5vh;
      // .el-menu-item{
      //   width:20vh;
      // }
      .el-menu-item {
        margin: 0 20px;
        height: 100%;
        display: flex;
        align-items: center;
        min-width: 30px;
        width: 10vh;
        justify-content: center;

        &:hover {
          background-color: #fff;
          color: #409eff !important;
          border-bottom: 1px solid #409eff;
        }
      }

      .el-menu-item.is-active {
        background-color: #fff !important;
        border-bottom: 1px solid #409eff;
      }
    }

    .btn {
      // position: absolute;
      // top: 8px;
      // right: 0%;
      // z-index: 2;
    }
  }

  .Box {
    // padding: 20px 30px;
    box-sizing: border-box;
    background: #fff;
    // background: #409eff;
    height: 100%;
  }

  .kb {
    width: 98px;
    height: 48px;
    position: absolute;
    top: 8px;
    right: 0%;
    background: #fff;
    z-index: 1;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  ::v-deep .el-dialog__header {
    text-align: center;
  }
}

.Bid .index {
  width: 100%;
  margin: auto;
  border-radius: 16px;
  position: relative;
}

.Bid .el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

.Bid .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.Bid .menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Bid /deep/.el-card__body,
.Bid .el-main {
  padding: 0px;
  padding-bottom: 20px;
}
</style>
